export default {"src":"/_next/static/media/spotify.79041818.svg","height":52,"width":94,"blurWidth":0,"blurHeight":0};